var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListMultiple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.8 10.548a1 1 0 011-1H32a1 1 0 011 1v21.467a1 1 0 01-1 1H14.8a1 1 0 01-1-1V10.548z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 28.748H9.533A2.133 2.133 0 017.4 26.615v-19.2c0-1.179.955-2.134 2.133-2.134h14.934c1.178 0 2.133.955 2.133 2.134v2.133",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 24.48H3.133A2.133 2.133 0 011 22.347v-19.2c0-1.178.955-2.133 2.133-2.133h14.934c1.178 0 2.133.955 2.133 2.133V5.28",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.467 14.881h4.267M18.067 14.881l1.067 1.067 2.133-2.133M24.467 21.281h4.267M18.067 21.281l1.067 1.067 2.133-2.133M24.467 27.681h4.267M18.067 27.681l1.067 1.067 2.133-2.133",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgListMultiple;